import { render } from "./UserData.vue?vue&type=template&id=788e7f4d"
import script from "./UserData.vue?vue&type=script&setup=true&lang=js"
export * from "./UserData.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/start/UserData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "788e7f4d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('788e7f4d', __exports__)) {
    api.reload('788e7f4d', __exports__)
  }
  
  module.hot.accept("./UserData.vue?vue&type=template&id=788e7f4d", () => {
    api.rerender('788e7f4d', render)
  })

}


export default __exports__